import { render } from "./add-distributor-setting-dialog.vue?vue&type=template&id=2298791b&scoped=true&ts=true"
import script from "./add-distributor-setting-dialog.vue?vue&type=script&lang=ts"
export * from "./add-distributor-setting-dialog.vue?vue&type=script&lang=ts"

import "./add-distributor-setting-dialog.vue?vue&type=style&index=0&id=2298791b&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2298791b"]])

export default __exports__